<script>
	import LinearProgress from '@smui/linear-progress';
</script>

<div class="flex flex-col items-center justify-center p-8 min-h-[400px]">
	<div class="w-full max-w-md">
		<LinearProgress indeterminate />
	</div>
	<p class="mt-4 text-lg font-medium text-gray-700">
		Caricamento in corso...
	</p>
	<p class="mt-2 text-sm text-gray-500">
		Attendere prego, l'operazione potrebbe richiedere alcuni secondi.
	</p>
</div>